import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  DialogContent,
  Typography,
  Grid,
  Select,
  MenuItem,
  FormControl,
  Box,
  FormHelperText,
} from "@material-ui/core";
import InputMask from "react-input-mask";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";

import { ProductTypeService } from "../../../services/productType.service";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  label: {
    marginBottom: "1.5vh",
  },
  formControl: {
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      width: 180,
    },
    [theme.breakpoints.down("sm")]: {
      width: 250,
    },
    minWidth: 200,
    width: 320,
  },
  box: {
    marginTop: "20px",
  },
}));

const ProviderForm = ({
  closeDialog,
  providerAction,
  addAlert,
  detailAlert,
}) => {
  const classes = useStyles();
  const [hasErrorProductType, setHasErrorProductType] = React.useState(false);
  const [provider, setProvider] = React.useState({});
  const [productTypeArray, setProductTypeArray] = React.useState([]);

  useEffect(() => {
    ProductTypeService.getProductTypes().then((resp) => {
      if (resp && resp.data) {
        setProductTypeArray(resp.data);
      }
    });
  }, []);

  const handleSubmitForm = (event) => {
    addAlert({ showAlert: false });
    event.preventDefault();
    if (productTypeArray.length === 0) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message:
          "Es necesario crear al menos una rol para poder guardar un nuevo proveedor",
      });
      return;
    }

    console.log("gets here");
    providerAction("create", provider);
    resetForm();
  };

  const handleInputText = (event) => {
    if (event.target.name === "productTypeId" && event.target.value)
      setHasErrorProductType(false);
    setProvider({
      ...provider,
      [event.target.name]: event.target.value,
    });
  };

  const resetForm = () => {
    setProvider({
      ...provider,
      name: "",
      alias: "",
      direction: "",
      timeGuarantee: "",
      productTypeId: "",
    });
  };

  return (
    <React.Fragment>
      <DialogContent>
        <ValidatorForm
          noValidate
          className={classes.form}
          method="POST"
          onSubmit={handleSubmitForm}
          onError={(errors) => console.log(errors)}
        >
          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="center"
          >
            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Box mb={3}>
                <Typography
                  variant="h5"
                  component={"div"}
                  style={{ color: "#0b148e" }}
                >
                  Nuevo Proveedor
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}></Grid>

            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  className={classes.label}
                  component={"div"}
                >
                  Nombre
                </Typography>
                <TextValidator
                  className={classes.inputField}
                  name="name"
                  value={provider.name || ""}
                  validators={["required"]}
                  onChange={(e) => handleInputText(e)}
                  errorMessages={["El nombre es requerido"]}
                  variant="outlined"
                  inputProps={{
                    maxLength: 50,
                  }}
                ></TextValidator>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  className={classes.label}
                  component={"div"}
                >
                  Alias
                </Typography>
                <TextValidator
                  className={classes.inputField}
                  name="alias"
                  value={provider.alias || ""}
                  validators={["required"]}
                  onChange={(e) => handleInputText(e)}
                  errorMessages={["El alias es requerido"]}
                  helperText="Nombre que visualizarán los vendedores"
                  variant="outlined"
                  inputProps={{
                    maxLength: 15,
                  }}
                ></TextValidator>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  className={classes.label}
                  component={"div"}
                >
                  Dirección
                </Typography>
                <TextValidator
                  className={classes.inputField}
                  name="direction"
                  value={provider.direction || ""}
                  validators={["required"]}
                  onChange={(e) => handleInputText(e)}
                  errorMessages={["La dirección es requerida"]}
                  variant="outlined"
                  multiline
                  rowsMax={5}
                  inputProps={{
                    maxLength: 100,
                  }}
                ></TextValidator>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  className={classes.label}
                  component={"div"}
                >
                  Tiempo de garantía
                </Typography>
                <InputMask
                  mask="999"
                  maskChar=""
                  value={provider.timeGuarantee || ""}
                  onChange={(e) => handleInputText(e)}
                >
                  {() => (
                    <TextValidator
                      className={classes.inputField}
                      name="timeGuarantee"
                      validators={["required"]}
                      errorMessages={["El tiempo de garantía es requerido"]}
                      helperText="Aplicada en días"
                      variant="outlined"
                    ></TextValidator>
                  )}
                </InputMask>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  className={classes.label}
                  component={"div"}
                >
                  Clave de producto (SAT)
                </Typography>
                <InputMask
                  mask="9999999999"
                  maskChar=""
                  value={provider.providerCode || ""}
                  onChange={(e) => handleInputText(e)}
                >
                  {() => (
                    <TextValidator
                      className={classes.inputField}
                      name="providerCode"
                      validators={["required"]}
                      errorMessages={["La clave del proveedor es obligatoría"]}
                      variant="outlined"
                    ></TextValidator>
                  )}
                </InputMask>
              </Box>
            </Grid>

            <Grid
              style={{ marginTop: 40, marginBottom: 30 }}
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <Button
                  color="primary"
                  style={{ marginRight: 50, width: 150 }}
                  onClick={() => {
                    closeDialog();
                    resetForm();
                  }}
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  style={{ width: 150 }}
                  variant="contained"
                  type="submit"
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </ValidatorForm>
      </DialogContent>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(ProviderForm);
